import { useEffect, useState } from "react";

function pad(n) { return n < 10 ? "0" + n : "" + n; }

export default function Countdown({ target }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const targetMs = new Date(target).getTime();
  const diff = Math.max(0, targetMs - now);
  const days = Math.floor(diff / (24 * 3600 * 1000));
  const hours = Math.floor((diff / (3600 * 1000)) % 24);
  const mins = Math.floor((diff / (60 * 1000)) % 60);
  const secs = Math.floor((diff / 1000) % 60);

  const box = (v, l) => (
    <div className="vp-countdown-box">
      <div className="font-mono text-3xl sm:text-4xl text-[#0B0D17]">{pad(v)}</div>
      <div className="vp-label mt-1">{l}</div>
    </div>
  );

  return (
    <div className="flex gap-3 sm:gap-4 flex-wrap" data-testid="webinar-countdown">
      {box(days, "days")}
      {box(hours, "hrs")}
      {box(mins, "min")}
      {box(secs, "sec")}
    </div>
  );
}
